export default "__VITE_ASSET__bd03aeaa__"